module.exports = __webpack_public_path__ + "static/media/kid-scooping-cookie-dough.a020dacb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2017-11-4/kid-scooping-cookie-dough.jpg
// module id = 400
// module chunks = 0